import { Instance, types } from 'mobx-state-tree';

const Service = types
	.model('Service', {
		id: types.identifierNumber,
		name: types.string,
		title: types.optional(types.string, ''),
		logo_url: types.maybe(types.optional(types.string, '')),
		tutorial_url: types.maybe(types.string),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}));

export default Service;

export interface IServiceModel extends Instance<typeof Service> {}
